import React from 'react';
import ColumnHeader from '../../../../ColumnHeader';

import styles from './attStandings.scss';

const Header = ({ gridLayout }) => {
    return (
        <div className={`${styles.headers} d-grid w-100`} style={{ gridTemplateColumns: gridLayout.join(' ') }}>
            <ColumnHeader columnName="Rank" />
            <ColumnHeader />
            <ColumnHeader columnName="Team Name" />
            <ColumnHeader
                columnName={(
                    <div className="w-100 text-center">
                        League
                        <br />
                        Record
                    </div>
                )}
            />
            <ColumnHeader
                columnName={(
                    <div className="w-100 text-center">
                        Overall
                        <br />
                        Record
                    </div>
                )}
            />
        </div>
    );
};

export default Header;
